



import SetupSidebar from '@/components/setup/SetupSidebar.vue'

export default {
    components: { SetupSidebar },
    name: 'index',
    middleware: 'userAuth',//中间件页面登录鉴权
    data() {
        return {
            src: `${process.env.NODE_ENV == 'development' ? 'https://sso.xp-pen.com' : 'https://account.xp-pen.com'}/thirdparty/index?lang=en`,//第三方绑定用总站
            loading: false
        };
    },
    mounted() {
        this.updated()
    },
    methods: {
        updated() {
            //iframe是否加载完
            var that = this
            this.loading = true
            const iframe = document.querySelector('#benefitnotice_iframe')
            // 处理兼容行问题
            if (iframe.attachEvent) {
                iframe.attachEvent('onload', function () {
                    that.loading = false
                })
            } else {
                iframe.onload = function () {
                    that.loading = false
                }
            }
        },
    }


}
